import { render, staticRenderFns } from "./screen-placeholder.vue?vue&type=template&id=46daee9b&scoped=true"
import script from "./screen-placeholder.vue?vue&type=script&lang=ts"
export * from "./screen-placeholder.vue?vue&type=script&lang=ts"
import style0 from "./screen-placeholder.vue?vue&type=style&index=0&id=46daee9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46daee9b",
  null
  
)

export default component.exports